import { motion } from "framer-motion";
import "./WhatsAppButton.css";

const WhatsAppButton = () => {
  const phoneNumber = "919978611325"; // Format: country code + number (no + or spaces)

  const handleClick = () => {
    const whatsappUrl = `https://wa.me/${phoneNumber}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div className="whatsapp-container">
      {/* Pulsing ring */}
      <motion.div
        className="whatsapp-pulse-ring"
        animate={{
          scale: [1, 1.5, 1.5],
          opacity: [0.7, 0, 0],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeOut",
          delay: 1,
        }}
      />

      {/* Main button */}
      <motion.button
        onClick={handleClick}
        className="whatsapp-button"
        aria-label="Chat on WhatsApp"
        whileHover={{
          scale: 1.1,
          rotate: [0, -10, 10, -10, 0],
          transition: { rotate: { duration: 0.5 } },
        }}
        whileTap={{ scale: 0.95 }}
        initial={{ scale: 0 }}
        animate={{
          scale: 1,
          rotate: [0, -5, 5, -5, 0],
        }}
        transition={{
          scale: { type: "spring", stiffness: 260, damping: 20 },
          rotate: {
            duration: 0.6,
            repeat: Infinity,
            repeatDelay: 3,
            ease: "easeInOut",
          },
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          aria-label="WhatsApp"
          role="img"
          viewBox="0 0 512 512"
          fill="#000000"
          className="whatsapp-icon"
        >
          <rect width="512" height="512" rx="15%" fill="#25d366"></rect>
          <path
            fill="#25d366"
            stroke="#ffffff"
            strokeWidth="26"
            d="M123 393l14-65a138 138 0 1150 47z"
          ></path>
          <path
            fill="#ffffff"
            d="M308 273c-3-2-6-3-9 1l-12 16c-3 2-5 3-9 1-15-8-36-17-54-47-1-4 1-6 3-8l9-14c2-2 1-4 0-6l-12-29c-3-8-6-7-9-7h-8c-2 0-6 1-10 5-22 22-13 53 3 73 3 4 23 40 66 59 32 14 39 12 48 10 11-1 22-10 27-19 1-3 6-16 2-18"
          ></path>
        </svg>
      </motion.button>
    </div>
  );
};

export default WhatsAppButton;